<template>
    <div class="modify-password">
        <!-- 密码修改表单 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-lock"></i>
                修改密码
            </h4>
            <el-form :model="formData" label-width="80px" :rules="rules" ref="passwordForm" size="small">
                <el-form-item prop="oldPassword" label="原密码">
                    <el-input v-model="formData.oldPassword" type="password" autocomplete="off" size="small" maxlength="20"
                        show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="newPassword" label="新密码">
                    <el-input v-model="formData.newPassword" type="password" autocomplete="off" size="small" maxlength="20"
                        show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="confirmPassword" label="确认密码">
                    <el-input v-model="formData.confirmPassword" type="password" autocomplete="off" size="small" maxlength="20"
                        show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-group">
                <el-button type="primary" @click="onSubmit()">提 交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "modifyPassword",
    data() {
        var checkPassword = (rule, value, callback) => {
            if (value === '') {
                return callback(new Error('请输入密码'));
            }
            callback();
        };
        var checkConfirmPassword = (rule, value, callback) => {
            if (value === '') {
                return callback(new Error('请输入密码'));
            }
            if (value != this.formData.newPassword) {
                return callback(new Error('两次密码输入不一致'));
            }
            callback();
        };
        return {
            formData: {
                oldPassword: "",
                newPassword: "",
                confirmPassword: ""
            },
            rules: {
                newPassword: [{
                    validator: checkPassword,
                    trigger: 'blur'
                }],
                oldPassword: [{
                    validator: checkPassword,
                    trigger: 'blur'
                }],
                confirmPassword: [{
                    validator: checkConfirmPassword,
                    trigger: 'blur'
                }]
            },
        }
    },
    methods: {
        onSubmit() {
            this.$refs.passwordForm.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.$http({
                    url: "/modifyPwd",
                    method: "put",
                    data: this.formData
                }).then((res) => {
                    this.$message.success("修改成功");
                })
            });
        }
    }
}
</script>
<style scoped lang="scss">
.modify-password {
    padding: 18px 20px 24px;
    background: transparent;
    min-height: 400px;

    // 表单区域 (glass-l1)
    .form-section {
        background: rgba(255, 252, 243, 0.62);
        backdrop-filter: blur(24px) saturate(140%);
        -webkit-backdrop-filter: blur(24px) saturate(140%);
        border: 0.5px solid var(--glass-border);
        border-radius: var(--radius-md);
        padding: 16px 18px;
        margin-bottom: 14px;
        box-shadow:
            inset 0 1px 0 0 var(--glass-border-inner),
            0 1px 2px rgba(31, 31, 35, 0.04),
            0 8px 24px rgba(31, 31, 35, 0.06);

        .section-title {
            margin: 0 0 14px 0;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: -0.3px;
            color: var(--im-text-color);
            display: flex;
            align-items: center;
            gap: 8px;
            padding-bottom: 10px;
            border-bottom: 0.5px solid var(--hairline-soft);

            i {
                color: var(--aurora-blue);
                font-size: 16px;
                background: linear-gradient(135deg, rgba(91, 141, 238, 0.14), rgba(168, 139, 255, 0.10));
                width: 26px; height: 26px;
                border-radius: 8px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    .btn-group {
        margin-top: 20px;
        display: flex;
        justify-content: center;

        .el-button {
            padding: 10px 36px;
            font-size: var(--im-font-size);
            font-weight: 600;
            min-width: 160px;
        }
    }
}
</style>
